import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/core';
import Telex from './telex';
import Parallax from 'parallax-js';
import Swup from 'swup';
import SwupPreloadPlugin from '@swup/preload-plugin';
import SwupMetaTagsPlugin from 'swup-meta-tags-plugin';
import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Scrollbar, { ScrollbarPlugin } from 'smooth-scrollbar';
import { primaryInput } from 'detect-it';
import "focus-visible";
import "./gsap/SplitText";

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

class MobilePlugin extends ScrollbarPlugin {
    static pluginName = 'mobile';
    static defaultOptions = {
        speed: 0.5,
    };

    transformDelta(delta, fromEvent) {
        if (fromEvent.type !== 'touchend') {
            return delta;
        }

        return {
            x: delta.x * this.options.speed,
            y: delta.y * this.options.speed,
        };
    }
}

Scrollbar.use(MobilePlugin);

import 'swiper/swiper-bundle.css';
import "./../scss/style.scss";

let parallaxScenes = [];

SwiperCore.use([Navigation, Pagination, Autoplay, EffectFade]);

const hasClass = (element, className) => {
    return (' ' + element.className + ' ').indexOf(' ' + className + ' ') > -1;
}

const mobileNavigationInit = () => {
    if (document.querySelector(".main-header__open-nav-button")) {
        const navTrigger = document.querySelector(".main-header__open-nav-button");
        navTrigger.addEventListener("click", (e) => {
            e.preventDefault();
            document.body.classList.add("has-mobile-navigation-open");
        })
    }
    if (document.querySelector(".main-header__close-nav-button")) {
        const closeTrigger = document.querySelector(".main-header__close-nav-button");
        closeTrigger.addEventListener("click", (e) => {
            e.preventDefault();
            document.body.classList.remove("has-mobile-navigation-open");
        })
    }
}

const reviewCarousel = () => {
    const reviewSwiper = new Swiper('.carousel-reviews',
        {
            loop: true,
            speed: 500,
            slidesPerView: 1,
            breakpoints: {
                768: {
                    slidesPerView: 2
                },
                1023: {
                    slidesPerView: 3
                }
            },
            pagination: {
                el: '.reviews__pager',
                type: 'bullets',
                bulletClass: "gallery__pager__button",
                bulletActiveClass: "is-selected",
                clickable: true,
                renderBullet: function (index, className) {
                    return '<button class="' + className + '"><div class="gallery__pager__button-image"></div></button>';
                }
            },
            autoplay: {
                delay: 4000,
            }
        }
    );
}

const instagramCarousel = () => {
    const instagramSwiper = new Swiper('.instagram-carousel',
        {
            loop: true,
            speed: 500,
            slidesPerView: 2,
            centeredSlides: true,
            breakpoints: {
                480: {
                    spaceBetween: 10
                },
                768: {
                    spaceBetween: 20
                },
                1023: {
                    slidesPerView: 4,
                    spaceBetween: 0,
                    centeredSlides: false,
                }
            },
            navigation: {
                nextEl: '.this-is-us__carousel__button--next',
                prevEl: '.this-is-us__carousel__button--prev',
            },
            autoplay: {
                delay: 4000,
            }
        }
    );
}

const galleryCarousel = () => {
    const gallerySwiper = new Swiper('.gallery-carousel',
        {
            loop: true,
            speed: 500,
            slidesPerView: 1,
            pagination: {
                el: '.gallery__pager',
                type: 'bullets',
                bulletClass: "gallery__pager__button",
                bulletActiveClass: "is-selected",
                clickable: true,
                renderBullet: function (index, className) {
                    return '<button class="' + className + '"><div class="gallery__pager__button-image"></div></button>';
                }
            },
            autoplay: {
                delay: 4000,
            }
        }
    );
}

const storyBoxCarousel = () => {
    if (document.querySelectorAll(".story-short-block__slider .swiper-slide").length > 1) {
        const storySwiper = new Swiper('.story-short-block__slider',
            {
                loop: true,
                speed: 500,
                slidesPerView: 1,
                pagination: {
                    el: '.story-short-block__slider-pager',
                    type: 'bullets',
                    bulletClass: "gallery__pager__button",
                    bulletActiveClass: "is-selected",
                    clickable: true,
                    renderBullet: function (index, className) {
                        return '<button class="' + className + '"><div class="gallery__pager__button-image"></div></button>';
                    }
                },
                autoplay: {
                    delay: 4000,
                }
            }
        );
    }
}

const marketplaceCarousel = () => {
    const storySwiper = new Swiper('.marketplace__slider',
        {
            loop: true,
            speed: 500,
            slidesPerView: 1,
            autoplay: {
                delay: 4000,
            }
        }
    );
}

const parallaxInit = () => {
    if (document.querySelectorAll(".story-scene")) {
        const scenes = document.querySelectorAll(".story-scene");
        for (let i = 0; i < scenes.length; i++) {
            const scene = scenes[i];
            const parallaxInstance = new Parallax(scene, {
                limitX: 1,
                scalarY: primaryInput === "touch" ? 3 : 10.0,
                scalarX: primaryInput === "touch" ? 3 : 10.0
            });
            parallaxScenes.push(parallaxInstance);
            gsap.to(scene, {
                opacity: 1,
                duration: 0.3,
            })
        }
    }
}

const parallaxDestroy = () => {
    if (parallaxScenes.length > 0) {
        for (let i = 0; i < parallaxScenes.length; i++) {
            const scene = parallaxScenes[i];
            scene.destroy();
        }
        parallaxScenes = [];
    }
}

const stickyHeader = (scrollEvent) => {
    const header = document.querySelector(".main-header");
    const sticky = header.offsetTop;
    if (scrollEvent.offset.y > sticky) {
        document.body.classList.add("has-sticky-header");
    } else {
        document.body.classList.remove("has-sticky-header");
    }
}

const getNewsFromPage = () => {
    const newsEls = document.querySelectorAll(".news-ticker__news")
    const newsArray = [];
    for (let i = 0; i < newsEls.length; i++) {
        const n = newsEls[i];
        const nObject = {
            id: `msg${i}`,
            content: n.innerHTML,
            class: "news-ticker__news"
        }
        newsArray.push(nObject);
    }
    if (newsArray)
        return newsArray;
}

export function newsTicker() {
    if (window.innerWidth >= 1024) {
        if (document.querySelector(`#news-ticker`)) {
            const news = getNewsFromPage()
            document.querySelector(`#news-ticker`).innerHTML = "";
            var qtx = Telex.widget("news-ticker", {
                speed: 20,
                pauseOnHover: true
            }, news);
        }
    } else {
        const newsSwiper = new Swiper('.news-ticker__news-wrapper',
            {
                effect: 'fade',
                autoplay: {
                    delay: 4000,
                },
                fadeEffect: {
                    crossFade: true
                },
                on: {
                    init: function () {
                        document.querySelector(".news-ticker__news-wrapper").classList.remove("is-not-initialized")
                    },
                }
            }
        );
    }
    document.querySelector(".news-ticker__label").addEventListener("click", (e) => {
        e.preventDefault();
        if (hasClass(document.body, "has-mobile-news-ticker-shown")) {
            document.body.classList.remove("has-mobile-news-ticker-shown");
        } else {
            document.body.classList.add("has-mobile-news-ticker-shown");
        }
    })
}

const handleStoryClick = (e) => {
    e.preventDefault();
    const storyButtons = document.querySelectorAll(".michela-nathan-navigation__button");
    const storyContents = document.querySelectorAll(".michela-nathan-content");
    const target = e.currentTarget.getAttribute("href");
    for (let x = 0; x < storyContents.length; x++) {
        const content = storyContents[x];
        if (content.classList.contains("is-active")) {
            content.classList.remove("is-active");
        }
    }
    if (!e.currentTarget.classList.contains("is-active")) {
        document.querySelector(target).classList.add("is-active")
        e.currentTarget.classList.add("is-active");
    } else {
        e.currentTarget.classList.remove("is-active");
    }
    for (let y = 0; y < storyButtons.length; y++) {
        const selButton = storyButtons[y];
        if (selButton !== e.currentTarget) {
            selButton.classList.remove("is-active");
        }
    }
}

const setNav = () => {
    const items = document.querySelectorAll(".main-header__main-navigation__item");
    for (let i = 0; i < items.length; i++) {
        const item = items[i];
        item.addEventListener("mouseover", (e) => {
            for (let s = 0; s < items.length; s++) {
                const it = items[s];
                if (it !== item) {
                    gsap.set(it, { autoAlpha: 0.4 });
                } else {
                    gsap.set(it, { autoAlpha: 1 });
                }
            }
        });
        item.addEventListener("mouseout", (e) => {
            for (let s = 0; s < items.length; s++) {
                const it = items[s];
                gsap.set(it, { autoAlpha: 1 });
            }
        });
    }
}

const activateMenu = (el) => {
    const items = document.querySelectorAll(".main-header__main-navigation__item");
    const activeDeco = document.querySelector(".active-item-deco");
    for (let i = 0; i < items.length; i++) {
        const item = items[i];
        item.classList.remove("is-active")
    }
    if (document.querySelector(`#${el}-nav-item`)) {
        const activeItem = document.querySelector(`#${el}-nav-item`);
        const activeItemStyle = getComputedStyle(activeItem);
        gsap.to(activeDeco, {
            x: activeItem.offsetLeft + parseFloat(activeItemStyle.paddingLeft),
            autoAlpha: el === "page-order" ? 0 : 1,
            width: activeItem.offsetWidth - parseFloat(activeItemStyle.paddingLeft) - parseFloat(activeItemStyle.paddingRight),
            duration: 0.3,
        })
        document.querySelector(`#${el}-nav-item`).classList.add("is-active");
    }
}

const scrollAfterHomeHero = () => {
    const scrollbar = Scrollbar.get(document.querySelector(".scroll-box"));
    scrollbar.scrollTo(0, window.pageYOffset + document.querySelector('.story-short-block').getBoundingClientRect().top - 110, 700)
    //scrollbar.scrollIntoView(document.querySelector('.story-short-block'), 700);
}

const onPageView = () => {
    if (document.querySelector('.main-wrapper')) {
        const id = document.querySelector('.main-wrapper').id;
        activateMenu(id);
    }
    if (document.querySelector('.carousel-reviews')) {
        reviewCarousel();
    }
    if (document.querySelector('.instagram-carousel')) {
        instagramCarousel();
    }
    if (document.querySelector('.gallery-carousel')) {
        galleryCarousel();
    }
    if (document.querySelector('.story-short-block__slider')) {
        storyBoxCarousel();
    }
    if (document.querySelector('.home-hero__scroll-down-button')) {
        document.querySelector(".home-hero__scroll-down-button").addEventListener("click", scrollAfterHomeHero)
    }
    /*if (document.querySelector('.michela-nathan-navigation__button')) {
        const storyButtons = document.querySelectorAll(".michela-nathan-navigation__button");
        for (let i = 0; i < storyButtons.length; i++) {
            const button = storyButtons[i];
            button.addEventListener("click", handleStoryClick)
        }
    }*/
    if (document.querySelector('.story-scene')) {
        parallaxInit();
    }
    if (document.querySelector('.marketplace__slider')) {
        marketplaceCarousel();
    }
    if (document.querySelector('.scroll-box')) {
        if (Scrollbar.has(document.querySelector('.scroll-box'))) {
            Scrollbar.destroy(Scrollbar.get(document.querySelector('.scroll-box')));
        }
        const scrollbar = Scrollbar.init(document.querySelector('.scroll-box'), {
            damping: 0.13,
            plugins: {
                mobile: {
                    speed: 0.5,
                }
            },
        });
        ScrollTrigger.scrollerProxy(document.body, {
            scrollTop(value) {
                if (arguments.length) {
                    scrollbar.scrollTop = value;
                }
                return scrollbar.scrollTop;
            },
            getBoundingClientRect() {
                return { top: 0, left: 0, width: window.innerWidth, height: window.innerHeight };
            }
        });
        scrollbar.addListener((s) => {
            stickyHeader(s);
            ScrollTrigger.update(s);
        });
    }
    prepareAnimations();
    prepareAnimatePastaGrid();
    prepareAnimateStory();
}

const onWillReplaceContent = () => {
    if (document.querySelector('.carousel-reviews')) {
        const reviewSwiper = document.querySelector('.carousel-reviews').swiper;
        reviewSwiper.destroy(true, true);
    }
    if (document.querySelector('.instagram-carousel')) {
        const instagramSwiper = document.querySelector('.instagram-carousel').swiper;
        instagramSwiper.destroy(true, true);
    }
    if (document.querySelector('.gallery-carousel')) {
        const gallerySwiper = document.querySelector('.gallery-carousel').swiper;
        gallerySwiper.destroy(true, true);
    }
    if (document.querySelector('.story-short-block__slider')) {
        const storySwiper = document.querySelector('.story-short-block__slider').swiper;
        if (storySwiper) {
            storySwiper.destroy(true, true);
        }
    }
    if (document.querySelector('.home-hero__scroll-down-button')) {
        document.querySelector(".home-hero__scroll-down-button").removeEventListener("click", scrollAfterHomeHero)
    }
    /*if (document.querySelector('.michela-nathan-navigation__button')) {
        const storyButtons = document.querySelectorAll(".michela-nathan-navigation__button");
        for (let i = 0; i < storyButtons.length; i++) {
            const button = storyButtons[i];
            button.removeEventListener("click", handleStoryClick)
        }
    }*/
    if (document.querySelector('.story-scene')) {
        parallaxDestroy();
    }
    if (document.querySelector('.marketplace__slider')) {
        const marketplaceSwiper = document.querySelector('.marketplace__slider').swiper;
        marketplaceSwiper.destroy(true, true);
    }
}

const onAnimationOutDone = () => {
    const scrollbar = Scrollbar.get(document.querySelector(".scroll-box"));
    window.scrollTo(0, 0)
    scrollbar.setPosition(0, 0);
}

const onAnimationInDone = () => {
    if (Scrollbar.has(document.querySelector('.scroll-box'))) {
        const scrollbar = Scrollbar.get(document.querySelector('.scroll-box'));
        scrollbar.update();
    }
    animations();
    animatePastaGrid();
    animateStory();
}

const prepareAnimations = () => {
    if (document.querySelector(".fade-in-bottom")) {
        gsap.set(".fade-in-bottom", { y: 50, autoAlpha: 0 });
    }
    if (document.querySelector(".fade-in")) {
        gsap.set(".fade-in", { autoAlpha: 0 });
    }
}

const animations = () => {
    if (document.querySelector(".fade-in-bottom")) {
        gsap.set(".fade-in-bottom", { y: 50, autoAlpha: 0 });

        ScrollTrigger.batch(".fade-in-bottom", {
            scrub: 1,
            interval: 0.1, // time window (in seconds) for batching to occur.
            onEnter: batch => gsap.to(batch, { autoAlpha: 1, y: 0, stagger: { each: 0.15 }, overwrite: true }),
            // you can also define most normal ScrollTrigger values like start, end, etc.
            start: "20px bottom",
            end: "top top"
        });
    }

    if (document.querySelector(".circle-rhombus")) {
        ScrollTrigger.create({
            trigger: ".circle-rhombus",
            onUpdate: self => gsap.to(self.trigger, {
                rotate: "+=" + (1 * (self.getVelocity() / 40)),
                ease: "power2.easeInOut"
            }),
            // you can also define most normal ScrollTrigger values like start, end, etc.
            start: "20px bottom",
            end: "top top"
        });
    }

    if (document.querySelector(".circle-waves")) {
        ScrollTrigger.create({
            trigger: ".circle-waves",
            onUpdate: self => gsap.to(self.trigger, {
                rotate: "+=" + (1 * (self.getVelocity() / 40)),
                ease: "power2.easeInOut"
            }),
            start: "20px bottom",
            end: "top top"
        });
    }

    if (document.querySelector(".new-badge__background")) {
        ScrollTrigger.create({
            trigger: ".new-badge__background",
            onUpdate: self => gsap.to(self.trigger, {
                rotate: "+=" + (1 * (self.getVelocity() / 40)),
                ease: "power2.easeInOut"
            }),
            start: "20px bottom",
            end: "top top"
        });
    }

    if (document.querySelector(".rossodoro_animation")) {
        const container = document.querySelector('.rossodoro_animation');
        const frames = container.querySelectorAll('img');
        const totalFrames = frames.length;

        ScrollTrigger.create({
            trigger: ".rossodoro_animation",
            start: "10% bottom",
            end: "center top",
            scrub: true,
            onUpdate: (self) => {
                const loopProgress = self.progress;
                const frameIndex = Math.min(Math.floor(loopProgress * totalFrames), totalFrames - 1);
                frames.forEach((frame, index) => {
                    frame.style.display = index === frameIndex ? "block" : "none";
                });
            }
        });
    }

    if (document.querySelector(".fade-in")) {
        gsap.set(".fade-in", { autoAlpha: 0 });

        ScrollTrigger.batch(".fade-in", {
            scrub: 1,
            interval: 0.1, // time window (in seconds) for batching to occur.
            batchMax: 10,   // maximum batch size (targets). Can be function-based for dynamic values
            onEnter: batch => gsap.to(batch, { autoAlpha: 1, stagger: { each: 0.15 }, overwrite: true }),
            // you can also define most normal ScrollTrigger values like start, end, etc.
            start: "20px bottom",
            end: "top top"
        });
    }
}

const prepareAnimatePastaGrid = () => {
    if (document.querySelector(".pasta-animation .pasta__image-wrapper")) {
        gsap.set(".pasta-animation .pasta__image-wrapper", { scale: 0.5, autoAlpha: 0 });
    }
    if (document.querySelector(".pasta-animation .pasta__name")) {
        gsap.set(".pasta-animation .pasta__name", { y: 30, autoAlpha: 0 });
    }
    if (document.querySelector(".pasta-animation .pasta__award__image")) {
        gsap.set(".pasta-animation .pasta__award__image", { scale: 0, autoAlpha: 0 });
    }
    if (document.querySelector(".pasta-list__item")) {
        gsap.set(".pasta-list__item", { y: 50, autoAlpha: 0 });
    }
}

const animatePastaGrid = () => {
    if (document.querySelector(".pasta-animation .pasta__image-wrapper")) {
        gsap.set(".pasta-animation .pasta__image-wrapper", { scale: 0.5, autoAlpha: 0 });

        ScrollTrigger.batch(".pasta-animation .pasta__image-wrapper", {
            scrub: 1,
            interval: 0.1, // time window (in seconds) for batching to occur.
            batchMax: 10,   // maximum batch size (targets). Can be function-based for dynamic values
            onEnter: batch => gsap.to(batch, { autoAlpha: 1, scale: 1, stagger: { each: 0.15 }, overwrite: true }),
            // you can also define most normal ScrollTrigger values like start, end, etc.
            start: "20px bottom",
            end: "top top"
        });
    }

    if (document.querySelector(".pasta-animation .pasta__name")) {
        gsap.set(".pasta-animation .pasta__name", { y: 30, autoAlpha: 0 });

        ScrollTrigger.batch(".pasta-animation .pasta__name", {
            scrub: 1,
            interval: 0.1, // time window (in seconds) for batching to occur.
            batchMax: 10,   // maximum batch size (targets). Can be function-based for dynamic values
            onEnter: batch => gsap.to(batch, { autoAlpha: 1, y: 0, stagger: { each: 0.15 }, overwrite: true }),
            // you can also define most normal ScrollTrigger values like start, end, etc.
            start: "20px bottom",
            end: "top top"
        });
    }

    if (document.querySelector(".pasta-animation .pasta__award__image")) {
        gsap.set(".pasta-animation .pasta__award__image", { scale: 0, autoAlpha: 0 });

        ScrollTrigger.batch(".pasta-animation .pasta__award__image", {
            scrub: 1,
            interval: 0.1, // time window (in seconds) for batching to occur.
            onEnter: batch => gsap.to(batch, {
                autoAlpha: 1,
                scale: 1,
                stagger: { each: 0.15 },
                overwrite: true,
                ease: "back.out(1)",
                delay: 0.3
            }),
            // you can also define most normal ScrollTrigger values like start, end, etc.
            start: "20px bottom",
            end: "top top"
        });
    }

    if (document.querySelector(".pasta-list__item")) {
        gsap.set(".pasta-list__item", { y: 50, autoAlpha: 0 });
        ScrollTrigger.batch(".pasta-list__item", {
            onEnter: batch => gsap.to(batch, { autoAlpha: 1, y: 0, stagger: { each: 0.15, grid: [1, 5] }, overwrite: true }),
        });
    }
}

const prepareAnimateStory = () => {
    if (document.querySelector(".enter-story-1 img")) {
        gsap.set(".enter-story-1 img", { translateX: "-100%" });
    }
    if (document.querySelector(".enter-story-2 img")) {
        gsap.set(".enter-story-2 img", { translateX: "100%" });
    }
    if (document.querySelector(".enter-story-3 img")) {
        gsap.set(".enter-story-3 img", { translateX: "-100%" });
    }
}

const animateStory = () => {
    if (document.querySelector(".enter-story")) {
        gsap.utils.toArray(".enter-story-1 img").forEach((elem, index) => {
            gsap.to(elem, {
                translateX: "0",
                scrollTrigger: {
                    trigger: elem,
                    start: `${index * 100}px bottom`,
                    end: "center center",
                    scrub: true
                }
            });
        });

        gsap.utils.toArray(".enter-story-2 img").forEach((elem, index) => {
            gsap.to(elem, {
                translateX: "0",
                scrollTrigger: {
                    trigger: elem,
                    start: `${index * 100}px bottom`,
                    end: "center center",
                    scrub: true
                }
            });
        });

        gsap.utils.toArray(".enter-story-3 img").forEach((elem, index) => {
            gsap.to(elem, {
                translateX: "0",
                scrollTrigger: {
                    trigger: elem,
                    start: `${index * 100}px bottom`,
                    end: "center center",
                    scrub: true
                }
            });
        });
    }
}

export function sitewide() {
    setNav();
    onPageView();
    mobileNavigationInit();
    onAnimationInDone();
    if (document.querySelector(".news-ticker")) {
        newsTicker();
    }
    document.querySelector(".main-footer__scroll-to-top-button").addEventListener("click", (e) => {
        e.preventDefault();
        const scrollbar = Scrollbar.get(document.querySelector(".scroll-box"));
        scrollbar.scrollTo(0, 0, 700)
    })
    const navAnchors = document.querySelectorAll(".main-header__main-navigation__anchor, .main-header__main-navigation__anchor-special");
    for (let ni = 0; ni < navAnchors.length; ni++) {
        const nEl = navAnchors[ni];
        nEl.addEventListener("click", (e) => {
            document.body.classList.remove("has-mobile-navigation-open");
        })
    }
    document.querySelector(".main-header__main-navigation__anchor--contact").addEventListener("click", (e) => {
        e.preventDefault();
        const scrollbar = Scrollbar.get(document.querySelector(".scroll-box"));
        scrollbar.scrollIntoView(document.querySelector('.main-footer'), {
            offsetTop: -110
        })
    })
    const swup = new Swup({
        animateHistoryBrowsing: true,
        plugins: [new SwupPreloadPlugin(), new SwupMetaTagsPlugin()]
    });
    swup.on('pageView', onPageView);
    swup.on('animationInDone', onAnimationInDone);
    swup.on('animationOutDone', onAnimationOutDone);
    swup.on('willReplaceContent', onWillReplaceContent);
    setTimeout(() => {
        gsap.to(".opening-overlay", {
            autoAlpha: 0,
            duration: 1,
            onComplete: () => {
                document.body.classList.remove("show-intro-overlay");
            }
        })
    }, 1500)
}
/*
export function moveX(value) {
    const scrollbar = Scrollbar.get(document.querySelector(".scroll-box"));
    scrollbar.setPosition(0, value);
}

export function getScrollbar() {
    Scrollbar.destroy(Scrollbar.get(document.querySelector('.scroll-box')));
    const scrollbar = Scrollbar.init(document.querySelector('.scroll-box'), {
        damping: 0.13,
        plugins: {
            mobile: {
                speed: 0.5,
            }
        },
    });
    return scrollbar;
}
*/
